module.exports = __webpack_public_path__ + "img/exchange.8c253c44.svg";